// src/components/investor/CardExpandChevron.tsx
//
// Shared expand/collapse chevron for investor cards. One size + alignment so the
// submission and dealflow lists don't drift. When `onToggle` is provided it is a
// standalone tappable target (the card body handles a different tap); when it's
// omitted the chevron is a plain indicator and the surrounding pressable owns the
// toggle.

import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react-native';
import AnimatedPressable from '@/components/AnimatedPressable';
import { useThemeColors } from '@/lib/useThemeColors';

interface CardExpandChevronProps {
  expanded: boolean;
  onToggle?: () => void;
  accessibilityLabel?: string;
}

export function CardExpandChevron({ expanded, onToggle, accessibilityLabel }: CardExpandChevronProps) {
  const colors = useThemeColors();
  const Icon = expanded ? ChevronUp : ChevronDown;
  const icon = <Icon size={16} color={colors.text.tertiary} />;

  if (!onToggle) return icon;

  return (
    <AnimatedPressable
      onPress={onToggle}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel ?? (expanded ? 'Collapse' : 'Expand')}
      hitSlop={8}
      pressScale={0.9}
      className="pl-1"
    >
      {icon}
    </AnimatedPressable>
  );
}
